export default __webpack_public_path__ + "static/media/optimization-square-bracket-left.99e30dd8.svg";